module.exports = __webpack_public_path__ + "static/img/icon-access-denied.aef9a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activities/icon-access-denied.png
// module id = fhFc
// module chunks = 134